import React from "react";
import { Link } from "react-router-dom";
import {
  MerchantOutletsIcon,
  MerchantSettingsIcon,
} from "../components/MerchantIcons";

const SHORTCUT_ITEMS = [
  {
    key: "outlets",
    title: "Outlets",
    subtitle: "Store performance and activity overview",
    path: "/outlets",
    icon: MerchantOutletsIcon,
  },
  {
    key: "settings",
    title: "Settings",
    subtitle: "Merchant profile, settlement, and notifications",
    path: "/settings",
    icon: MerchantSettingsIcon,
  },
];

export default function MerchantShortcutPage() {
  return (
    <div className="merchant-page merchant-shortcut-page">
      <div className="merchant-page-header">
        <div className="merchant-page-title">More</div>
        <div className="merchant-page-subtitle">
          Merchant tools and secondary pages
        </div>
      </div>

      <div className="merchant-data-note">
        Mobile shortcut hub for merchant sections outside the bottom navigation.
      </div>

      <div className="merchant-shortcut-grid">
        {SHORTCUT_ITEMS.map(function renderShortcut(item) {
          const Icon = item.icon;

          return (
            <Link className="merchant-shortcut-card" key={item.key} to={item.path}>
              <div className="merchant-shortcut-icon">
                <Icon />
              </div>
              <div className="merchant-shortcut-copy">
                <div className="merchant-shortcut-title">{item.title}</div>
                <div className="merchant-shortcut-subtitle">{item.subtitle}</div>
              </div>
              <span className="merchant-shortcut-arrow">→</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
